import { NgModule,
    Component }                 from '@angular/core';
import { NavController,
    IonicApp,
    IonicModule}                from 'ionic-angular';
import { ViewChild }            from    '@angular/core';
import { Platform }             from 'ionic-angular';
import {FaceBookService}        from '../../providers/facebook-provider';

declare var window: any;

@Component({
    selector: 'login-starter',
    templateUrl: 'startup.page.html'
})
export class loginStarterComponent {    
    constructor(
        private platform: Platform,
        private faceBookService: FaceBookService
    ) {
    }    
}



// WEBPACK FOOTER //
// ./src/app/feature/loginModule/pages/startup/startup.page.ts